import React, { useContext, useEffect, useState, useMemo } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col, Modal } from "react-bootstrap";
import PageLayout from "../../layouts/PageLayout";
import axios from "axios";
import JoditEditor from 'jodit-react';
import './UserProfilePage.css';
import './ContentView.css';
import { API_URL, APP_PREFIX_PATH } from "../../constant/constant";
import { t } from "i18next";

export default function ContentViewComponent() {
    const [modalShow, setModalShow] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [emptyContent, setEmptyContent] = useState('');
    const [content, setContent] = useState(1);

    const [about, setAbout] = useState('');
    const [about1, setAbout1] = useState('');
    const [terms, setTerms] = useState('');
    const [terms1, setTerms1] = useState('');
    const [privacy, setPrivacy] = useState('');
    const [privacy1, setPrivacy1] = useState('');
    const [android, setAndroid] = useState('');
    const [ios, setIos] = useState('');
    const [share, setShare] = useState('');

    const contentTypes = {
        'about us': 1,
        'about us1': 1,
        'privacy policy': 2,
        'privacy policy1': 2,
        'terms and condition': 3,
        'terms and condition1': 3,
        'android app url': 4,
        'ios app url': 5,
        'share message': 6,
        'about arabic': 8,
        'privacy policy arabic': 9,
        'terms and condition arabic': 10
    };

    // Fetching content on component mount
    useEffect(() => {
        fetchContent('about us', setAbout);
        fetchContent('about us', setAbout1);
        fetchContent('terms and condition', setTerms);
        fetchContent('terms and condition', setTerms1);
        fetchContent('privacy policy', setPrivacy);
        fetchContent('privacy policy', setPrivacy1);
        fetchContent('android app url', setAndroid);
        fetchContent('ios app url', setIos);
        fetchContent('share message', setShare);
    }, []);

    // Function to fetch content
    // const fetchContent = (contentType, setter) => {
    //     axios.post(`${API_URL}/fetch_content`, { content_type: contentTypes[contentType] })
    //         .then(response => {
    //             if (response.data.success && response.data.content_arr?.length > 0) {
    //                 setter(response.data.content_arr[0].content);
    //             } else {
    //                 setter('');
    //             }
    //         })
    //         .catch(() => setter(''));
    // };
    const fetchContent = (contentType, setter) => {
        axios.post(`${API_URL}/fetch_content`, { content_type: contentTypes[contentType] })
            .then(response => {
                if (response.data.success && response.data.content_arr?.length > 0) {
                    const content = response.data.content_arr[0];
                    if (contentType === 'about us') {
                        setAbout(content.content);
                        setAbout1(content.content_1);
                    }
                    if (contentType === 'terms and condition') {
                        setTerms(content.content);
                        setTerms1(content.content_1);
                    }
                    if (contentType === 'privacy policy') {
                        setPrivacy(content.content);
                        setPrivacy1(content.content_1);
                    }
                    if (contentType === 'android app url') {
                        setAndroid(content.content);

                    }
                    if (contentType === 'ios app url') {
                        setIos(content.content);

                    }
                    if (contentType === 'share message') {
                        setShare(content.content);

                    }
                } else {
                    setter('');
                }
            })
            .catch(() => setter(''));
    };

    // Configuration for the editor
    const config1 = useMemo(() => ({
        readonly: false,
        placeholder: '',
        defaultActionOnPaste: 'insert_as_html',
        buttons: [
            'bold', 'italic', '|',
            'ul', 'ol', '|',
            'font', 'fontsize', '|',
            'outdent', 'indent', 'align', '|',
            'hr', '|', 'fullsize', 'brush', '|',
            'table', 'link', '|',
            'undo', 'redo'
        ],
        statusbar: false,
        toolbarAdaptive: false
    }), []);

    // const handleBanner = (contentType) => {
    //     let contentStateToUpdate;
    //     switch (contentType) {
    //         case 'about us': contentStateToUpdate = about; break;
    //         case 'privacy policy': contentStateToUpdate = privacy; break;
    //         case 'terms and condition': contentStateToUpdate = terms; break;
    //         case 'android app url': contentStateToUpdate = android; break;
    //         case 'ios app url': contentStateToUpdate = ios; break;
    //         case 'share message': contentStateToUpdate = share; break;
    //         default: return;
    //     }
    //     console.log('contentStateToUpdate', contentStateToUpdate);


    //     if (!contentStateToUpdate || contentStateToUpdate.trim() === '') {
    //         setEmptyContent('This field cannot be empty.');
    //         return;
    //     }


    //     axios.post(API_URL + '/edit_content', {
    //         content_type: contentTypes[contentType],
    //         content: contentStateToUpdate
    //     })
    //         .then((response) => {
    //             console.log("res", response)
    //             if (response.data.success) {

    //                 setToastMessage(`${contentType} updated successfully`);
    //                 setModalShow(true);
    //                 setTimeout(() => setModalShow(false), 2000);
    //                 setEmptyContent('');
    //             }
    //         })
    //         .catch(() => {
    //             setModalShow(true);
    //             setTimeout(() => setModalShow(false), 2000);
    //             setEmptyContent('Failed to update.');
    //         });
    // };
    // Function to handle input change and update state
    const handleInputChange = (contentType, value) => {
        switch (contentType) {
            case 'about us':
                setAbout(value);
                break;
            case 'about us1':
                setAbout1(value);
                break;
            case 'privacy policy':
                setPrivacy(value);
                break;
            case 'privacy policy1':
                setPrivacy1(value);
                break;
            case 'terms and condition':
                setTerms(value);
                break;
            case 'terms and condition1':
                setTerms1(value);
                break;
            case 'android app url':
                setAndroid(value);
                break;
            case 'ios app url':
                setIos(value);
                break;
            case 'share message':
                setShare(value);
                break;
            default:
                return;
        }
    };


    const handleBanner = (contentType) => {
        let contentStateToUpdate;


        switch (contentType) {
            case 'about us': contentStateToUpdate = about; break;
            case 'about us1': contentStateToUpdate = about1; break;
            case 'privacy policy': contentStateToUpdate = privacy; break;
            case 'privacy policy1': contentStateToUpdate = privacy1; break;
            case 'terms and condition': contentStateToUpdate = terms; break;
            case 'terms and condition1': contentStateToUpdate = terms1; break;
            case 'android app url': contentStateToUpdate = android; break;
            case 'ios app url': contentStateToUpdate = ios; break;
            case 'share message': contentStateToUpdate = share; break;
            default: return;
        }


        if (!contentStateToUpdate.trim()) {
            setEmptyContent(t("this_field_cannt_empty"));
            return;
        }

        console.log(contentType, 'trimmed content:', contentStateToUpdate);


        const payload = {
            content_type: contentTypes[contentType],
            ...(contentType === 'about us1' || contentType === 'privacy policy1' || contentType === 'terms and condition1'
                ? { content_1: contentStateToUpdate }
                : { content: contentStateToUpdate })
        };

        // Send the API request
        axios.post(API_URL + '/edit_content', payload)
            .then((response) => {
                if (response.data.success) {
                    console.log('response', response)
                    if (contentType === 'about us1') {
                        setToastMessage(`about us updated successfully`);
                    }
                    else if (contentType === 'privacy policy1') {
                        setToastMessage(`privacy policy updated successfully`);
                    }
                    else if (contentType === 'terms and condition1') {
                        setToastMessage(`terms and condition updated successfully`);
                    }
                    else {
                        setToastMessage(`${contentType} updated successfully`);
                    }

                    setModalShow(true);
                    setTimeout(() => setModalShow(false), 2000);
                    setEmptyContent('');
                } else {
                    setToastMessage(`${contentType} update failed`);
                    setModalShow(true);
                    setTimeout(() => setModalShow(false), 2000);
                }
            })
            .catch(() => {
                setModalShow(true);
                setTimeout(() => setModalShow(false), 2000);
                setEmptyContent('Failed to update.');
            });
    };

    const handleButtonClick = (contentType) => {
        setContent(contentTypes[contentType]);
    };

    return (
        <PageLayout>
            <Col xl={12}>
                <div className="mc-card">
                    <div className='mc-breadcrumb'>
                        <h3 className="mc-breadcrumb-title">{t('content_details')}</h3>
                        <ul className="mc-breadcrumb-list">
                            <li className="mc-breadcrumb-item"><Link to={`${APP_PREFIX_PATH + '/dashboard'}`} className="mc-breadcrumb-link">{t('home')}</Link></li>
                            <li className="mc-breadcrumb-item">
                                <Link to='#' className="mc-breadcrumb-link">{t('content')}</Link>
                            </li>
                            <li className="mc-breadcrumb-item">{t('content_list')}</li>
                        </ul>
                    </div>
                </div>
            </Col>
            <div className="mc-card p-lg-4">
                <Row>
                    <Col xl={12}>
                        <nav className="mt-4 navbar navbar-expand-lg navbar-light navBar">
                            <div className="container navbar-responsive">
                                <button
                                    className={`btn me-0 ms-0 btn-contentt ${content === 1 ? 'active' : ''}`}
                                    type="button"
                                    onClick={() => handleButtonClick('about us')}
                                >
                                    {t("about")}
                                </button>
                                <button
                                    className={`btn me-0 btn-contentt ${content === 2 ? 'active' : ''}`}
                                    type="button"
                                    onClick={() => handleButtonClick('privacy policy')}
                                >
                                    {t("privacy")}
                                </button>
                                <button
                                    className={`btn me-0 btn-contentt ${content === 3 ? 'active' : ''}`}
                                    type="button"
                                    onClick={() => handleButtonClick('terms and condition')}
                                >
                                    {t("terms")}
                                </button>

                                <button
                                    className={`btn me-0 btn-contentt ${content === 4 ? 'active' : ''}`}
                                    type="button"
                                    onClick={() => handleButtonClick('android app url')}
                                >
                                    {t("android")}
                                </button>
                                <button
                                    className={`btn me-0 btn-contentt ${content === 5 ? 'active' : ''}`}
                                    type="button"
                                    onClick={() => handleButtonClick('ios app url')}
                                >
                                    {t("ios")}
                                </button>
                                <button
                                    className={`btn me-0 btn-contentt ${content === 6 ? 'active' : ''}`}
                                    type="button"
                                    onClick={() => handleButtonClick('share message')}
                                >
                                    {t("send_message")}
                                </button>

                            </div>
                        </nav>
                        <br />
                        <div className="user-details">
                            {content === 1 && (
                                <div>
                                    <div className="lagnuge">
                                        <button
                                            className={`btn me-0 ms-2 btn-contentt  ${content === 1 ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => handleButtonClick('about us')}
                                        >
                                            {t("english")}
                                        </button>
                                        <button
                                            className={`btn me-0 btn-contentt ${content === 8 ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => handleButtonClick('about arabic')}
                                        >
                                            {t("arabic")}
                                        </button>
                                    </div><br />
                                    <span>{t("about")}</span>
                                    <JoditEditor
                                        value={about}
                                        config={config1}
                                        onChange={(content) => { handleInputChange('about us', content); setEmptyContent(''); }}
                                    />
                                    <p style={{ color: 'red' }}>{emptyContent}</p><br />
                                    <button className="btn" onClick={() => handleBanner('about us')} style={{ backgroundColor: '#0F225D', color: 'white' }}>{t("update")}</button>
                                </div>
                            )}
                            {content === 8 && (
                                <div>
                                    <div className="lagnuge">
                                        <button
                                            className={`btn me-0 ms-2 btn-contentt  active ${content === 1 ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => handleButtonClick('about us')}
                                        >
                                            {t("english")}
                                        </button>
                                        <button
                                            className={`btn me-0 btn-contentt ${content === 8 ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => handleButtonClick('about arabic')}
                                        >
                                            {t("arabic")}
                                        </button>
                                    </div><br />
                                    <span>عنا</span>
                                    <JoditEditor
                                        value={about1}
                                        config={config1}
                                        onChange={(content) => { handleInputChange('about us1', content); setEmptyContent(''); }}
                                    />
                                    <p style={{ color: 'red' }}>{emptyContent}</p><br />
                                    <button className="btn" onClick={() => handleBanner('about us1')} style={{ backgroundColor: '#0F225D', color: 'white' }}>{t("update")}</button>
                                </div>
                            )}

                            {content === 2 && (
                                <div>
                                    <div className="lagnuge">
                                        <button
                                            className={`btn me-0 ms-2 btn-contentt  active ${content === 1 ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => handleButtonClick('privacy policy')}
                                        >
                                            {t("english")}
                                        </button>
                                        <button
                                            className={`btn me-0 btn-contentt ${content === 9 ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => handleButtonClick('privacy policy arabic')}
                                        >
                                            {t("arabic")}
                                        </button>
                                    </div><br />
                                    <span>{t("privacy")}</span>
                                    <JoditEditor
                                        value={privacy}
                                        config={config1}
                                        onChange={(content) => { handleInputChange('privacy policy', content); setEmptyContent(''); }}
                                    />
                                    <p style={{ color: 'red' }}>{emptyContent}</p><br />
                                    <button className="btn" onClick={() => handleBanner('privacy policy')} style={{ backgroundColor: '#0F225D', color: 'white' }}>{t("update")}</button>
                                </div>
                            )}
                            {content === 9 && (
                                <div>
                                    <div className="lagnuge">
                                        <button
                                            className={`btn me-0 ms-2 btn-contentt  active ${content === 2 ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => handleButtonClick('privacy policy')}
                                        >
                                            {t("english")}
                                        </button>
                                        <button
                                            className={`btn me-0 btn-contentt ${content === 9 ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => handleButtonClick('privacy policy arabic')}
                                        >
                                            {t("arabic")}
                                        </button>
                                    </div><br />
                                    <span>سياسة الخصوصية</span>
                                    <JoditEditor
                                        value={privacy1}
                                        config={config1}
                                        onChange={(content) => { handleInputChange('privacy policy1', content); setEmptyContent(''); }}
                                    />
                                    <p style={{ color: 'red' }}>{emptyContent}</p><br />
                                    <button className="btn" onClick={() => handleBanner('privacy policy1')} style={{ backgroundColor: '#0F225D', color: 'white' }}>{t("update")}</button>
                                </div>
                            )}
                            {content === 3 && (
                                <div>
                                    <div className="lagnuge">
                                        <button
                                            className={`btn me-0 ms-2 btn-contentt  active ${content === 7 ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => handleButtonClick('terms and condition')}
                                        >
                                            {t("english")}
                                        </button>
                                        <button
                                            className={`btn me-0 btn-contentt ${content === 10 ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => handleButtonClick('terms and condition arabic')}
                                        >
                                            {t("arabic")}
                                        </button>
                                    </div>
                                    <span>{t("terms")}</span>
                                    <JoditEditor
                                        value={terms}
                                        config={config1}
                                        onChange={(content) => { handleInputChange('terms and condition', content); setEmptyContent(''); }}
                                    />
                                    <p style={{ color: 'red' }}>{emptyContent}</p><br />
                                    <button className="btn" onClick={() => handleBanner('terms and condition')} style={{ backgroundColor: '#0F225D', color: 'white' }}>{t("update")}</button>
                                </div>
                            )}
                            {content === 10 && (
                                <div>
                                    <div className="lagnuge">
                                        <button
                                            className={`btn me-0 ms-2 btn-contentt  active ${content === 3 ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => handleButtonClick('terms and condition')}
                                        >
                                            {t("english")}
                                        </button>
                                        <button
                                            className={`btn me-0 btn-contentt ${content === 8 ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => handleButtonClick('terms and condition arabic')}
                                        >
                                            {t("arabic")}
                                        </button>
                                    </div>
                                    <span>الشروط والأحكام</span>
                                    <JoditEditor
                                        value={terms1}
                                        config={config1}
                                        onChange={(content) => { handleInputChange('terms and condition1', content); setEmptyContent(''); }}
                                    />
                                    <p style={{ color: 'red' }}>{emptyContent}</p><br />
                                    <button className="btn" onClick={() => handleBanner('terms and condition1')} style={{ backgroundColor: '#0F225D', color: 'white' }}>{t("update")}</button>
                                </div>
                            )}
                            {content === 4 && (
                                <div>
                                    <span>{t("android")}</span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={android}
                                        onChange={(e) => { handleInputChange('android app url', e.target.value); setEmptyContent(''); }}
                                        placeholder={t("android")}
                                    />
                                    <p style={{ color: 'red' }}>{emptyContent}</p><br />
                                    <button className="btn" onClick={() => handleBanner('android app url')} style={{ backgroundColor: '#0F225D', color: 'white' }}>{t("update")}</button>
                                </div>
                            )}
                            {content === 5 && (
                                <div>
                                    <span>{t("ios")}</span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={ios}
                                        onChange={(e) => { handleInputChange('ios app url', e.target.value); setEmptyContent(''); }}
                                        placeholder={t("ios")}
                                    />
                                    <p style={{ color: 'red' }}>{emptyContent}</p><br />
                                    <button className="btn" onClick={() => handleBanner('ios app url')} style={{ backgroundColor: '#0F225D', color: 'white' }}>{t("update")}</button>
                                </div>
                            )}
                            {content === 6 && (
                                <div>
                                    <span>{t("send_message")}</span>
                                    <textarea
                                        className="form-control"
                                        value={share}
                                        onChange={(e) => { handleInputChange('share message', e.target.value); setEmptyContent(''); }}
                                        placeholder={t("send_message")}
                                        rows="3"
                                    />
                                    <p style={{ color: 'red' }}>{emptyContent}</p><br />
                                    <button className="btn" onClick={() => handleBanner('share message')} style={{ backgroundColor: '#0F225D', color: 'white' }}>{t("update")}</button>
                                </div>
                            )}
                        </div>
                    </Col>
                </Row>

                {/* Toast Notification */}
                <Modal show={modalShow} onHide={() => setModalShow(false)} className="custom-modal">
                    <Modal.Header closeButton className="border-0">
                        <Modal.Title className="w-100 text-center">
                            {t("update")}
                            <hr className="my-2" style={{ borderTop: '2px solid #007bff', width: '100%' }} />
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center">
                        <p className="lead mb-4">{toastMessage}</p>
                    </Modal.Body>
                    <Modal.Footer className="border-0 justify-content-center">

                    </Modal.Footer>
                </Modal>
            </div>
        </PageLayout>
    );
}
